"use client"

import { usePathname, useSearchParams } from "next/navigation"
import { Suspense, useEffect, useRef } from "react"

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

function MetaPixelTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  // The base pixel code already fires a PageView on first load, so skip it here.
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    window.fbq?.("track", "PageView")
  }, [pathname, searchParams])

  return null
}

/** Fires a Meta Pixel PageView on client-side route changes. */
export function MetaPixel() {
  return (
    <Suspense fallback={null}>
      <MetaPixelTracker />
    </Suspense>
  )
}
